<div class="filter-list" [class.filter-list--events-compact]="compact">
  <!-- Keyword (always visible) -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Business Name (optional)</h2>
    <div class="filter-list__group-content">
      <input id="rentalSalesName" type="text" class="landing-page__field landing-page__query-field"
             [(ngModel)]="rentalSalesFinderFilter.name" (input)="onNameChange()"
             aria-label="Business Name" autocomplete="off" autocorrect="off"
             [attr.aria-invalid]="nameTooShort ? true : null"
             [attr.aria-describedby]="nameTooShort ? 'rentalSalesNameError' : null">
      <div *ngIf="nameTooShort" id="rentalSalesNameError" class="rental-sales-filter__validation-message" role="alert">
        Please enter at least three characters to search by business name.
      </div>
    </div>
  </div>
</div>

<!-- Selected-filter chips: the first few active filters (click a chip to remove it) plus a "+N more" marker,
     so selections stay visible even when every section is collapsed. -->
<div class="filter-list rental-sales-filter__chips-wrapper" *ngIf="visibleChips.length > 0">
  <div class="rental-sales-filter__chips">
    <button class="rental-sales-filter__chip" *ngFor="let chip of visibleChips; trackBy: trackByChip"
            type="button" [title]="chip.label" [attr.aria-label]="'Remove ' + chip.label"
            (click)="onToggleFacet(chip.group, chip.value, false)">
      <span class="rental-sales-filter__chip-label">{{ chip.label }}</span>
      <mat-icon class="rental-sales-filter__chip-remove">close</mat-icon>
    </button>
    <span class="rental-sales-filter__chip-more" *ngIf="overflowCount > 0">+{{ overflowCount }} more</span>
  </div>
</div>

<!-- Collapsible facet sections. Each is collapsible and its header shows a badge with the number of selected
     filters. -->
<div class="filter-list rental-sales-filter__sections">
  <div class="filter-list__group" *ngFor="let section of sections">
    <button type="button" class="rental-sales-filter__section-header"
            [class.rental-sales-filter__section-header--open]="expanded[section.key]"
            [attr.aria-expanded]="expanded[section.key]"
            (click)="toggleSection(section.key)">
      <span class="rental-sales-filter__section-title">{{ section.title }}</span>
      <span class="rental-sales-filter__section-badge" *ngIf="sectionBadgeCount(section) > 0">{{ sectionBadgeCount(section) }}</span>
      <mat-icon class="rental-sales-filter__section-chevron">{{ expanded[section.key] ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>

    <div class="rental-sales-filter__section-body" *ngIf="expanded[section.key]">
      <ng-container *ngIf="section.options.length">
        <div class="filter-list__group-buttonbar">
          <span class="filter-list__group-button" (click)="onSelectAll(section.key, section.options)">Select All</span> |
          <span class="filter-list__group-button" (click)="onClearAll(section.key)">Clear All</span>
        </div>
        <div class="filter-list__group-content rental-sales-filter__section-options">
          <div class="filter" *ngFor="let option of section.options">
            <mat-checkbox [checked]="isFacetSelected(section.key, option.value)"
                          (change)="onToggleFacet(section.key, option.value, $event.checked)"
                          [attr.aria-label]="option.label" class="filter__checkbox">
              <div class="filter__header"><span class="filter__label">{{ option.label }}</span></div>
            </mat-checkbox>
          </div>
        </div>
      </ng-container>

      <!-- Nested, indented subsections (Sales > Aircraft Sale Type / Aircraft Manufacturers / Avionics
           Manufacturers), all at the same level, at the bottom of the parent section. -->
      <div class="rental-sales-filter__subsection" *ngFor="let sub of section.subsections">
        <button type="button" class="rental-sales-filter__subsection-header"
                [class.rental-sales-filter__section-header--open]="expanded[sub.key]"
                [attr.aria-expanded]="expanded[sub.key]"
                (click)="toggleSection(sub.key)">
          <span class="rental-sales-filter__section-title">{{ sub.title }}</span>
          <span class="rental-sales-filter__section-badge" *ngIf="selectedCount(sub.key) > 0">{{ selectedCount(sub.key) }}</span>
          <mat-icon class="rental-sales-filter__section-chevron">{{ expanded[sub.key] ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
        <div class="rental-sales-filter__section-body" *ngIf="expanded[sub.key]">
          <div class="filter-list__group-buttonbar">
            <span class="filter-list__group-button" (click)="onSelectAll(sub.key, sub.options)">Select All</span> |
            <span class="filter-list__group-button" (click)="onClearAll(sub.key)">Clear All</span>
          </div>
          <div class="filter-list__group-content rental-sales-filter__section-options">
            <div class="filter" *ngFor="let option of sub.options">
              <mat-checkbox [checked]="isFacetSelected(sub.key, option.value)"
                            (change)="onToggleFacet(sub.key, option.value, $event.checked)"
                            [attr.aria-label]="option.label" class="filter__checkbox">
                <div class="filter__header"><span class="filter__label">{{ option.label }}</span></div>
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
